import { Component, effect, input, Input, OnChanges, OnInit, signal, SimpleChanges, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button'
import { MatTableModule, MatRow, MatTableDataSource } from '@angular/material/table'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckbox } from '@angular/material/checkbox'
import { CommonModule, DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import { style, state, trigger, transition, animate } from '@angular/animations';
import { Subject, takeUntil } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { DosingGoalResponse } from '../../../models/dosing.model';

@Component({
  selector: 'app-dosinggoals',
   imports: [ MatTableModule,  MatPaginatorModule, MatSortModule, MatFormFieldModule,
    MatInputModule, MatButtonModule, MatSelectModule, MatDatepickerModule, FormsModule,
    MatMenuModule, MatProgressBarModule, MatProgressSpinnerModule, MatCardModule, MatSelectModule, CommonModule],

  templateUrl: './dosinggoals.component.html',
  styleUrl: './dosinggoals.component.scss'
})
export class DosinggoalsComponent {
    @Input() site: DosingGoalResponse[] = [];
    totalGpd: number = this.site.reduce((sum, item) => sum + item.dosing_goal_gpd, 0) ;
    totalTpd: number = this.site.reduce((sum, item) => sum + item.dosing_goal_tpd, 0) ;
    

}
